var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h1',{staticClass:"\n    custom-text\n    text-ms\n    py-3\n    w-full\n    ease-linear\n    transition-all\n    duration-150\n  ",class:_vm.getPaddingLeftRight,attrs:{"value":"United States"}},[_vm._v(" + ")])}
var staticRenderFns = []

export { render, staticRenderFns }